module.exports = __webpack_public_path__ + "static/supportlang-8269ebc9db1b0245311284a8e90f44cf.png";